import React from 'react';

const ReachChartSkeleton = () => (
  <div
    className='rounded-lg p-6'
    style={{ background: 'var(--bg-card)', border: '1px solid var(--border)' }}
  >
    <div className='flex items-center gap-2 mb-4'>
      <div className='skeleton w-5 h-5 rounded' />
      <div className='skeleton h-5 rounded w-24' />
      <div className='skeleton h-3 rounded w-28' />
    </div>
    <div className='grid grid-cols-2 gap-4 mb-6'>
      <div className='rounded-lg p-3' style={{ background: 'var(--bg-surface)', border: '1px solid var(--border-subtle)' }}>
        <div className='skeleton h-3 rounded w-20 mb-2' />
        <div className='skeleton h-6 rounded w-24' />
      </div>
      <div className='rounded-lg p-3' style={{ background: 'var(--bg-card-alt)', border: '1px solid var(--border)' }}>
        <div className='skeleton h-3 rounded w-20 mb-2' />
        <div className='skeleton h-6 rounded w-24' />
      </div>
    </div>
    <div className='skeleton h-64 rounded' />
  </div>
);

export default ReachChartSkeleton;
